import React, { Component } from "react";
import {
  getProductDetailListByProductCategoryIdRequest,
  updateProductDetailStatusByProductDetailIdRequest,
  deleteProductDetailByProductDetailIdRequest,
} from "store/actions";

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";
import Switch from "react-switch";
import { makeProductDetailSelectField } from "store/ProductDetail/selector";
import { createStructuredSelector } from "reselect";
import CustomDataTable from "components/Application/CustomDataTable";
import { confirmBox } from "helpers/messageHelper";
import { primaryColor, secondaryColor } from "scss/variables.module.scss";
import CircularIconButton from "components/Buttons/CircularIconButton";

const columns = [
  {
    label: "Sequence",
    field: "productSeq",
  },
  {
    label: "Product Name",
    field: "productName",
  },
  {
    label: "Product Description",
    field: "productDesc",
  },
  {
    label: "Product Category Name",
    field: "productCategoryName",
  },
  {
    label: "Status",
    field: "status",
    sort: "disabled",
  },
  {
    label: "Actions",
    field: "actions",
    sort: "disabled",
  },
];

class ProductDetailList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      productDetailRecords: [],
    };
  }

  onStatusChange = (checked, e, id) => {
    this.props.updateProductDetailStatusByProductDetailIdRequest(id, checked);
  };

  buildProductDetailDataTable = (records) => {
    this.setState({
      productDetailRecords: records.map((productDetail) => {
        let actions = (
          <div className="text-center">
            <CircularIconButton
              icon="fa fa-plus-circle fa-lg"
              onClick={this.viewManageUnit(productDetail)}
              tooltip={"Manage Units"}
            />

            <CircularIconButton
              icon="far fa-images fa-lg"
              onClick={this.managePhotosOfProductDetail(productDetail)}
              tooltip={"Manage Images"}
            />
            <CircularIconButton
              icon="far fa-edit fa-lg"
              onClick={this.viewProductDetail(productDetail)}
              tooltip={"Edit"}
            />

            <CircularIconButton
              icon="far fa-trash-alt fa-lg"
              onClick={this.deleteProductDetail(productDetail.productDetailId)}
              tooltip={"Delete"}
            />
          </div>
        );

        let status = (
          <div className="d-flex">
            <Switch
              className="switch-sm"
              onColor={primaryColor}
              offColor={secondaryColor}
              onChange={(checked, e, id) => this.onStatusChange(checked, e, id)}
              id={productDetail.productDetailId + ""}
              checked={productDetail.status ? true : false}
            />
            &nbsp;
          </div>
        );

        return {
          productSeq: productDetail.productSeq,
          productCategoryName: productDetail.productCategoryName,
          productName: productDetail.productName,
          productDesc: productDetail.productDesc,
          status: status,
          actions: actions,
        };
      }),
    });
  };

  UNSAFE_componentWillReceiveProps(nextprops) {
    if (this.props.productDetailData !== nextprops.productDetailData) {
      this.buildProductDetailDataTable(nextprops.productDetailData);
    }
    if (
      nextprops.productCategoryId &&
      this.props.productCategoryId !== nextprops.productCategoryId
    ) {
      this.props.getProductDetailListByProductCategoryIdRequest(
        nextprops.productCategoryId
      );
    }
  }

  viewProductDetail = (productDetailData) => () => {
    this.props.onViewProductDetail(productDetailData);
  };

  viewManageUnit = (productDetailData) => () => {
    this.props.onViewManageUnit(productDetailData);
  };

  managePhotosOfProductDetail = (productDetailData) => () => {
    this.props.history.push("/product/" + productDetailData.productDetailId);
  };

  deleteProductDetail = (productDetailId) => async () => {
    const response = await confirmBox();
    if (response) {
      this.props.deleteProductDetailByProductDetailIdRequest(productDetailId);
    }
  };

  render() {
    const data = {
      columns: columns,
      rows: this.state.productDetailRecords,
    };

    return (
      <React.Fragment>
        <CustomDataTable data={data} />
      </React.Fragment>
    );
  }
}

const mapStatetoProps = createStructuredSelector({
  productDetailData: makeProductDetailSelectField("productDetailData"),
});

const withConnect = connect(mapStatetoProps, {
  getProductDetailListByProductCategoryIdRequest,
  updateProductDetailStatusByProductDetailIdRequest,
  deleteProductDetailByProductDetailIdRequest,
});

export default compose(withConnect, withRouter)(ProductDetailList);
